import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    if (!error.response || [502, 503, 504].includes(status)) {
      window.dispatchEvent(new Event("pmo-server-down"));
    }
    if (status === 402) {
      import("sonner").then(({ toast }) => {
        toast.warning(formatApiErrorDetail(error.response?.data?.detail), {
          duration: 9000,
          action: { label: "See plans", onClick: () => { window.location.href = "/pricing"; } },
        });
      });
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatApiError(err, fallback = "Something went wrong") {
  if (!err?.response) {
    if (err?.code === "ECONNABORTED") return `${fallback}: the request timed out. Try again or use a smaller file.`;
    return `${fallback}: could not reach the server (network error). Check your connection and try again.`;
  }
  const { status, statusText, data } = err.response;
  if (data?.detail != null) return formatApiErrorDetail(data.detail);
  if (status === 413) return `${fallback}: the file is too large for the server to accept. Try a smaller file.`;
  if (status === 401) return `${fallback}: your session has expired. Please sign in again.`;
  if (status >= 500) return `${fallback}: the server hit an unexpected error (HTTP ${status}). Please try again — if it keeps happening, report it via Feedback.`;
  return `${fallback} (HTTP ${status}${statusText ? " " + statusText : ""}).`;
}

export default api;
